module.exports = __webpack_public_path__ + "static/favicon-96x96-f11899808b3d7c88cdf35b1a1a2097cc.png";